module.exports = __webpack_public_path__ + "static/media/operador-logo-dental-uni.08887dfb.png";